import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ButtonModule } from 'primeng/button';
import { AuthService } from 'src/app/service/auth.service';
import { AccountService } from 'src/app/service/account.service';

@Component({
  selector: 'app-subscription-success',
  standalone: true,
  imports: [CommonModule, ProgressSpinnerModule, ButtonModule],
  templateUrl: './subscription-success.component.html',
  styleUrl: './subscription-success.component.css',
})
export class SubscriptionSuccessComponent implements OnInit, OnDestroy {
  status: 'polling' | 'success' | 'error' = 'polling';
  private timer: any;
  private attempts = 0;
  private readonly MAX_ATTEMPTS = 30;
  private readonly POLL_INTERVAL_MS = 3000;

  constructor(
    private router: Router,
    private authService: AuthService,
    private accountService: AccountService,
  ) {}

  ngOnInit(): void {
    this.poll();
  }

  private poll(): void {
    const userId = this.authService.getUserInformations();
    this.timer = setInterval(() => {
      this.attempts++;
      this.accountService.getAccount(userId).subscribe({
        next: (account) => {
          if (account.planInformation?.status === 'active') {
            this.clearTimer();
            this.status = 'success';
            const returnUrl = sessionStorage.getItem('subscriptionReturnUrl') ?? '/my-garage';
            sessionStorage.removeItem('subscriptionReturnUrl');
            setTimeout(() => this.router.navigateByUrl(returnUrl), 1500);
          } else if (this.attempts >= this.MAX_ATTEMPTS) {
            this.clearTimer();
            this.status = 'error';
          }
        },
        error: () => {
          if (this.attempts >= this.MAX_ATTEMPTS) {
            this.clearTimer();
            this.status = 'error';
          }
        },
      });
    }, this.POLL_INTERVAL_MS);
  }

  private clearTimer(): void {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  goToDashboard(): void {
    sessionStorage.removeItem('subscriptionReturnUrl');
    this.router.navigate(['/my-garage']);
  }

  ngOnDestroy(): void {
    this.clearTimer();
  }
}
